import { render, staticRenderFns } from "./stationery.vue?vue&type=template&id=00123e81&scoped=true"
import script from "./stationery.vue?vue&type=script&lang=js"
export * from "./stationery.vue?vue&type=script&lang=js"
import style0 from "./stationery.vue?vue&type=style&index=0&id=00123e81&prod&lang=scss&scoped=true"
import style1 from "./stationery.vue?vue&type=style&index=1&id=00123e81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00123e81",
  null
  
)

export default component.exports